<template>
    <el-drawer v-model="state.visible" modal-class="aaa" :modal="false" class="drawer-record" size="100%"
        title="充值/调减记录" z-index="99">
        <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 100px)" row-key="id"
            v-loading="state.tableLoading" :row-class-name="tableRowClassName">
            <el-table-column prop="type" label="操作类型" min-width="150px">
                <template #default="scope">
                    <el-text class="mx-1" type="success" v-if="scope.row?.type == '充值'">
                        <!-- 充值/调减 -->
                        {{ scope.row?.type }}
                    </el-text>
                    <el-text class="mx-1" type="danger" v-else>
                        <!-- 充值/调减 -->
                        {{ scope.row?.type }}
                    </el-text>
                </template>
            </el-table-column>
            <el-table-column prop="adjAmt" label="调整金额" min-width="150px">
                <template #default="scope">
                    <el-text class="mx-1" type="primary">
                        {{ formatCurrency(scope.row?.adjAmt / 100, 2, '.', ',') }}
                    </el-text>
                </template>
            </el-table-column>
            <el-table-column prop="curAmt" label="操作后余额" min-width="150px">
                <template #default="scope">
                    <el-text class="mx-1" type="primary">
                        {{ formatCurrency(scope.row?.curAmt / 100, 2, '.', ',') }}
                    </el-text>
                </template>
            </el-table-column>
            <el-table-column prop="operationPhone" label="操作人手机号" min-width="180px" />
            <el-table-column prop="createTime" label="操作时间" min-width="180px" />
        </el-table>
    </el-drawer>
</template>
<script setup>
import { reactive, ref, defineExpose } from "vue";
import { getRechargeRecordFun } from "@/api/recharge"
import { formatCurrency } from "@/util/formValidator";
const state = reactive({
    userId: '',
    visible: false,
    tableLoading: false,
});
const tableData = ref([]);
const showDrawer = (userId) => {
    state.visible = true;
    if (state.userId != userId) {
        state.userId = userId;
        tableData.value = [];
        getTableData();
    }
}
// 获取表格数据
const getTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['userId'],
        formValue: {
            userId: state.userId
        }
    }
    getRechargeRecordFun(params).then((res) => {
        tableData.value = res.data.records;
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 区分行状态
const tableRowClassName = ({ row }) => {
    if (row.type === '充值') {
        return 'success-row'
    } else if (row.type === '调减') {
        return 'warning-row'
    }
    return '';
}
defineExpose({
    state,
    showDrawer
});
</script>
<style lang="scss">
.drawer-record {
    .el-drawer__body {
        padding-top: 0 !important;
    }

    .warning-row {
        --el-table-tr-bg-color: var(--el-color-warning-light-9);
    }

    .success-row {
        --el-table-tr-bg-color: var(--el-color-success-light-9);
    }
}

.aaa {
    width: 60%;
    left: auto !important;
}
</style>